import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useAppSelector } from "src/app/hooks";
import { useTranslate } from "src/locales";
import { referenceService } from "../../../api/references/referenceService";
import ByzAsynchronousSelectV2 from "src/components/core-components/ByzAsynchronousSelectV2";
import { DepartmentResponseDto } from "../../../api/references/referenceServicesDtos";

interface DepartmentListProps {
  handleChange: (value: any | any[]) => void;
  multiple?: boolean;
  value?: DepartmentResponseDto | DepartmentResponseDto[] | null;
  sx?: any;
  offId?: number;
}

export default function DepartmentList({
  handleChange,
  multiple = false,
  value,
  sx,
  offId,
}: DepartmentListProps) {
  const [selectedDepartment, setSelectedDepartment] = useState<
    | DepartmentResponseDto
    | DepartmentResponseDto[]
    | null
  >(null);

  const { user, selectedOfficeId: reduxOfficeId } = useAppSelector((state) => state.auth);

  // Eğer prop olarak offId gelmişse onu kullan, gelmemişse Redux'tan bul
  const effectiveOffId = useMemo(() => {
    if (offId && offId > 0) return offId;

    const selectedOffice = user?.UserAssPriviliges?.find(office => office.ID === reduxOfficeId);
    return Number(selectedOffice?.OFF_ID || user?.UserAssPriviliges?.[0]?.OFF_ID);
  }, [offId, reduxOfficeId, user]);

  const { t } = useTranslate();

  const fetchDepartments = useCallback(async (): Promise<DepartmentResponseDto[]> => {
    const response = await referenceService.department.getAllDepartmentsByOffId({ offId: effectiveOffId });
    return response;
  }, [effectiveOffId]);

  // Şube veya Kat değiştiğinde seçili departmanı sıfırla
  useEffect(() => {
    setSelectedDepartment(null);
    handleChange(null);
  }, [effectiveOffId]);

  if (!user) {
    return null;
  }
  return (
    <ByzAsynchronousSelectV2<DepartmentResponseDto>
      fetchOptions={fetchDepartments}
      label={t("department")}
      onChange={(value) => {
        setSelectedDepartment(value);
        handleChange(value);
      }}
      value={value ?? selectedDepartment}
      selectLabel="Name"
      multiple={multiple}
      sx={sx}
    />
  );
}
